import { Inject, Injectable } from '@angular/core';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';

import makeDebug from '../../../../makeDebug';
import { ClientDataSyncService } from '../../services/client-data-sync.service';
import { IClientDataSyncService } from '../../services/contracts/sync/client-data-sync';
import { NetworkInfoService } from '../../services/network/network-info.service';
import { ISyncContext } from '../contracts/sync/sync-context';
import { ISyncElement } from '../contracts/sync/sync-element';
import { SyncStarter as Starter } from '../contracts/sync/sync-endpoints';

const debug = makeDebug('sync:sync-starter');

@Injectable()
export class SyncStarter implements ISyncElement {
  public get name(): string {
    return Starter;
  }
  private _isRunning = false;

  constructor(
    @Inject(ClientDataSyncService) private _clientDataSyncService: IClientDataSyncService,
    @Inject(PlatformSyncToken) private _platformSync: IPlatformSync,
    private readonly _networkInfoService: NetworkInfoService
  ) {}

  public async execute(context: ISyncContext): Promise<void> {
    debug('entered execute function', context);
    await this._platformSync.ready;

    if (
      !this._platformSync.canBeSynced ||
      !context.params.isOnline ||
      this._networkInfoService.isConnectionSlow ||
      this._isRunning ||
      context.params.token.cancelled.get()
    ) {
      return;
    }

    this._isRunning = true;

    debug('calling startSync of client-data-sync-service');

    await this._clientDataSyncService
      .startSync(context.params.token)
      .catch(error => window.logger.error('Client sync failed', error));

    this._isRunning = false;
  }
}
